import React from "react";
import styles from "./booking-flow-page-heading.module.css";

type BookingFlowPageHeadingProps = {
    title: string;
    subtitle?: string;
    size?: "default" | "large";
    /** Widen title/subtitle at md+ (lab step desktop frame in Turnaround v3). */
    responsive?: boolean;
    /** Let subtitle use full card width instead of `--bf-content-max`. */
    subtitleFullWidth?: boolean;
    /** Reduce space below subtitle (payment confirmation line → due strip). */
    tightSubtitle?: boolean;
};

const BookingFlowPageHeading: React.FunctionComponent<BookingFlowPageHeadingProps> = ({
    title,
    subtitle,
    size = "default",
    responsive = false,
    subtitleFullWidth = false,
    tightSubtitle = false,
}) => {
    const titleClass = [
        styles.title,
        size === "large" ? styles.titleLarge : "",
        responsive ? styles.titleResponsive : "",
    ]
        .filter(Boolean)
        .join(" ");
    const subtitleClass = [
        styles.subtitle,
        size === "large" ? styles.subtitleLarge : "",
        responsive ? styles.subtitleResponsive : "",
        subtitleFullWidth ? styles.subtitleFullWidth : "",
        tightSubtitle ? styles.subtitleTight : "",
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <header>
            <h1 className={titleClass}>{title}</h1>
            {subtitle ? <p className={subtitleClass}>{subtitle}</p> : null}
        </header>
    );
};

export default BookingFlowPageHeading;
